module.exports = __webpack_public_path__ + "static/media/ExportIcon.cf266564.svg";